import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=63297e79"
import script from "./notification.js?vue&type=script&lang=js&external"
export * from "./notification.js?vue&type=script&lang=js&external"
import style0 from "./notification.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports